import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import ActionButton from 'components/ActionButton';
import PrivacyPolicy from 'components/PrivacyPolicy';
import { setDetail } from 'actions/storage';
import { AlertHeader, AlertContent, AlertButtons, AlertFooter } from 'assets/styles/sharedStyles';
import globalMessages from 'components/globalMessages';

import { StyledTitle } from '../TermsAndConditionsAlert/styles';

const messages = defineMessages({
  header: {
    defaultMessage: 'Privacy Policy',
  },
  confirm: {
    defaultMessage: 'I Agree',
  },
});

const PrivacyPolicyAlert = ({ closeAlert = () => {}, acceptTermsAction, confirmMethod }) => (
  <>
    <AlertHeader>
      <StyledTitle>
        <FormattedMessage {...messages.header} />
      </StyledTitle>
    </AlertHeader>
    <AlertContent>
      <PrivacyPolicy className="u-textLeft" />
    </AlertContent>
    <AlertFooter>
      <AlertButtons>
        <ActionButton
          dangerButton={true}
          label={<FormattedMessage {...globalMessages.cancel} />}
          onClick={closeAlert}
        />
        <ActionButton
          primaryButton={true}
          label={<FormattedMessage {...messages.confirm} />}
          onClick={() => {
            confirmMethod();
            closeAlert(acceptTermsAction(true));
          }}
        />
      </AlertButtons>
    </AlertFooter>
  </>
);

PrivacyPolicyAlert.propTypes = {
  closeAlert: PropTypes.func,
  acceptTermsAction: PropTypes.func,
  confirmMethod: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  acceptTermsAction: value => dispatch(setDetail('terms', value)),
});

export default connect(undefined, mapDispatchToProps)(PrivacyPolicyAlert);
